import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useDashboardTheme } from '../contexts/DashboardThemeContext';

export default function DashboardThemeControl() {
  const { theme, selectTheme, message } = useDashboardTheme();
  const Icon = theme === 'system' ? Monitor : theme === 'light' ? Sun : Moon;
  return <div className="dashboard-theme-control">
    <label><Icon size={17} aria-hidden="true" /><span className="dashboard-theme-label">Appearance</span>
      <select aria-label="Dashboard appearance" value={theme} onChange={event => selectTheme(event.target.value)}>
        <option value="dark">Dark</option><option value="light">Light</option><option value="system">System</option>
      </select>
    </label>
    {message && <span className="dashboard-theme-message" role="status">{message}</span>}
  </div>;
}
